var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.device_type == 'card')?_c('b-icon',{attrs:{"icon":"credit-card","size":_vm.size}}):_c('b-icon',{attrs:{"icon":"access-point","size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }